/* eslint-disable import/prefer-default-export */
import uuidv1 from 'uuid/v1';

export const pinToDashMixin = {
  methods: {
    async pinToDash(entityType, entity) {
      const result = await this.$store.dispatch('pinToDash', { entityType, entity });
      if (result) {
        // add notification
        await this.$store.dispatch('addNotification', {
          id: uuidv1(),
          type: 'info', // available: 'warning', 'error', 'progress'
          unread: true,
          label: `Successfully pinned ${entity ? entity.name : entityType} to dashboard`,
          timestamp: Date.now()
        });
        this.$buefy.toast.open({
          message: 'Pinned successfully!',
          type: 'is-success',
          position: 'is-top-right'
        })
      }
    }
  }
}
